__turbopack_context__.v({
  "btnWrapper": "portals-module__Oi6KkG__btnWrapper",
  "title": "portals-module__Oi6KkG__title",
});
